<template>
  <div v-loading="loading" element-loading-text="加载中...">
    <el-card :body-style="{'padding-bottom': '0px'}">
      <div slot="header">
        <span>报备查询&nbsp;/&nbsp;报备管理&nbsp;/&nbsp;溯源管理</span>
      </div>
      <el-form ref="form" :inline="true" :model="queryParams.cur">
        <el-form-item prop="productName">
          <el-input v-model="queryParams.cur.productName" placeholder="食材名称"/>
        </el-form-item>
        <el-form-item prop="parentProductName">
          <el-input v-model="queryParams.cur.parentProductName" placeholder="所属组合"/>
        </el-form-item>
        <el-form-item prop="purchaseMode">
          <el-select v-model="queryParams.cur.purchaseMode" placeholder="采购方式" clerable>
            <el-option label="自主采购" :value="3"/>
            <el-option label="平台采购" :value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderNo">
          <el-select v-model="queryParams.cur.orderNo" placeholder="订单号" clerable>
            <el-option
              v-for="(item, idx) in (data && data.orders) || []"
              :key="idx"
              :label="item.orderNo"
              :value="item.orderNo"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="$refs.form.resetFields()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 8px">
      <div slot="header">
        <div style="display: flex; color: #606266">
          <div class="info-item" style="padding-left: 0">
            <div>办宴人:</div>
            <div>{{ data.organizer || '-' }}</div>
          </div>
          <div class="info-item">
            <div>乡厨:</div>
            <div>{{ data.ruralKitchenName || '-' }}</div>
          </div>
          <div class="info-item">
            <div>办宴时间:</div>
            <div>{{ data.dinnerTime || '-' }}</div>
          </div>
          <div class="info-item">
            <div>食材数量:</div>
            <div style="color: #13A25E">● {{ (data.list && data.list.length) || 0 }}</div>
          </div>
        </div>
      </div>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column type="index" label="编号" width="80" :index="1"/>
        <el-table-column prop="productName" label="食材名称" min-width="120"/>
        <el-table-column prop="purchaseModeName" label="采购方式" min-width="120"/>
        <el-table-column prop="parentProductName" label="所属组合" min-width="120"/>
        <el-table-column prop="yzOrderSn" label="订单号" min-width="120"/>
        <el-table-column prop="specs" label="食材规格" min-width="120"/>
        <el-table-column fixed="right" label="操作" width="130" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.purchaseMode === 3" size="mini" type="text" class="table-action-btn" @click="handleViewFiles(scope.row)">
              查看附件
            </el-button>
            <template v-else-if="scope.row.purchaseMode === 2">
              <el-button type="text" size="mini" class="table-action-btn" @click="handleViewQrcode(scope.row)">二维码
              </el-button>
              <el-button type="text" size="mini" class="table-action-btn" @click="handleGoSource(scope.row)">溯源报告
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <qrcode-dialog ref="qrcodeDialog"/>
    <image-list-dialog ref="imageListDialog" />
  </div>
</template>
<script>

import QrcodeDialog from "@/components/QrcodeDialog.vue";
import ImageListDialog from "@/components/ImageListDialog.vue";

export default {
  name: "bbqueryProduct",
  components: {ImageListDialog, QrcodeDialog},
  data() {
    return {
      loading: false,
      data: {
        orders: [],
        list: []
      },
      query: {},
      queryParams: {
        cur: {
          productName: null,
          parentProductName: null,
          purchaseMode: null,
          orderNo: null
        },
        pre: {}
      }
    };
  },
  created() {
    this.query = this.$route.query
  },
  mounted() {
    this.getData()
  },
  computed: {
    tableData() {
      if (!this.data || !this.data.list || this.data.list.length <= 0) {
        return []
      }
      const filter = i => {
        if (this.queryParams.pre.productName) {
          if (i.productName.indexOf(this.queryParams.pre.productName) === -1) {
            return false
          }
        }
        if (this.queryParams.pre.parentProductName) {
          if (!i.parentProductName || i.parentProductName.indexOf(this.queryParams.pre.parentProductName) === -1) {
            return false
          }
        }
        if (this.queryParams.pre.purchaseMode) {
          if (i.purchaseMode !== this.queryParams.pre.purchaseMode) {
            return false
          }
        }
        if (this.queryParams.pre.orderNo) {
          if (i.orderNo !== this.queryParams.pre.orderNo) {
            return false
          }
        }
        return true
      }
      return this.data.list.filter(filter)
    }
  },
  methods: {
    getData() {
      const {id} = this.query || {}
      if (!id) {
        this.$message.warning('缺少参数')
        return
      }

      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.loading = true;
      this.$axios.post(
        `/api-r/report/trace/${id}`,
        null,
        {headers: {accessToken: userdata.token},}
      ).then((res) => {
        if (res.data.success) {
          this.data = res.data || {}
        } else {
          // this.data = {
          //   organizer: '举办者',
          //   ruralKitchenName: '大厨',
          //   dinnerTime: '2022-01-01 11:22:33',
          //   orders: [
          //     {orderNo: 'dd01'},
          //     {orderNo: 'dd02'}
          //   ],
          //   list: [
          //     {
          //       productName: 'xxx食材',
          //       purchaseMode: 3,
          //       purchaseModeName: '自采',
          //       parentProductName: '',
          //       orderNo: '',
          //       specs: '',
          //     },
          //     {
          //       productName: 'xxx食材',
          //       purchaseMode: 3,
          //       purchaseModeName: '自采',
          //       parentProductName: '',
          //       orderNo: '',
          //       specs: '',
          //       appendixes: ['https://t7.baidu.com/it/u=1595072465,3644073269&fm=193&f=GIF', 'https://t7.baidu.com/it/u=2168645659,3174029352&fm=193&f=GIF','https://t7.baidu.com/it/u=1595072465,3644073269&fm=193&f=GIF', 'https://t7.baidu.com/it/u=2168645659,3174029352&fm=193&f=GIF','https://t7.baidu.com/it/u=1595072465,3644073269&fm=193&f=GIF', 'https://t7.baidu.com/it/u=2168645659,3174029352&fm=193&f=GIF','https://t7.baidu.com/it/u=1595072465,3644073269&fm=193&f=GIF', 'https://t7.baidu.com/it/u=2168645659,3174029352&fm=193&f=GIF','https://t7.baidu.com/it/u=1595072465,3644073269&fm=193&f=GIF', 'https://t7.baidu.com/it/u=2168645659,3174029352&fm=193&f=GIF']
          //     },
          //     {
          //       productName: 'xxx食材',
          //       purchaseMode: 3,
          //       purchaseModeName: '自采',
          //       parentProductName: '',
          //       orderNo: '',
          //       specs: '',
          //       appendixes: ['https://t7.baidu.com/it/u=4162611394,4275913936&fm=193&f=GIF']
          //     },
          //     {
          //       productName: '土豆丝',
          //       purchaseMode: 2,
          //       purchaseModeName: '平台',
          //       parentProductName: '青椒土豆丝',
          //       orderNo: 'dd01',
          //       specs: '散装',
          //     },
          //     {
          //       productName: '青椒丝',
          //       purchaseMode: 2,
          //       purchaseModeName: '平台',
          //       parentProductName: '青椒土豆丝',
          //       orderNo: 'dd01',
          //       specs: '散装',
          //     },
          //   ]
          // }
          this.$message(res.data.msg);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleGoSource(row) {
      if(!row.sourceUrl) {
        this.$message.warning('无溯源报告')
        return
      }

      window.open(row.sourceUrl, "_blank", 'height=800, width=400, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no');
    },
    handleViewQrcode(row) {
      this.$refs.qrcodeDialog.open({
        value: row.sourceUrl
      })
    },
    handleViewFiles(row) {
      this.$refs.imageListDialog.open({
        list: row.appendixes || []
      })
    },
    handleSearch() {
      this.queryParams.pre = JSON.parse(JSON.stringify(this.queryParams.cur))
    }
  },
};
</script>
<style scoped>
.info-item {
  padding: 0 16px;
}

.table-action-btn {
  padding: 0;
}
</style>
